import styled from "styled-components";

export const EditTournamentBaseWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const EditTournamentBaseContent = styled.div<{ $isRow?: boolean }>`
  position: relative;
  background: #fff;
  width: 100%;
  box-sizing: border-box;
  border-radius: 16px;
  border: 1px solid #f0f0f0;
  display: flex;
  flex-direction: ${({ $isRow: isRow }) => (isRow ? "row" : "column")};
  justify-content: ${({ $isRow: isRow }) =>
    isRow ? "space-between" : "flex-start"};
  gap: 12px;
  padding: 15px;

  > .title {
    color: #121212;
    font-family: Pretendard;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 120%; /* 19.2px */
  }

  > .description {
    color: #808080;
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%; /* 16.8px */
  }
`;

export const EditTournamentInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const EditTournamentInputBoxWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
`;

export const EditTournamentInputBox = styled.div<{ $isRow?: boolean }>`
  display: flex;
  flex-direction: ${({ $isRow: isRow }) => (isRow ? "row" : "column")};
  align-items: ${({ $isRow: isRow }) => (isRow ? "center" : "flex-start")};
  gap: 8px;
  position: relative;
  flex: 1;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;

  > .name {
    font-family: Pretendard;
    font-weight: 500;
    font-size: 14px;
    color: #121212;
    flex-shrink: 0;
    width: ${({ $isRow: isRow }) => (isRow ? "50px" : "auto")};
  }

  > input {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
    height: 44px;
    border-radius: 14px;
    padding: 12px 16px;
    border: 1px solid #e5e5e5;
    outline: none;
    font-family: Pretendard;
    font-weight: 400;
    font-size: 16px;
  }

  /* iOS Safari: date/time 기본 통·내부 여백 완화 */
  > input[type="date"],
  > input[type="time"] {
    -webkit-appearance: none;
    appearance: none;
  }

  > input[type="date"]::-webkit-datetime-edit,
  > input[type="time"]::-webkit-datetime-edit {
    padding: 0;
  }

  > span {
    position: absolute;
    right: 16px;
    top: ${({ $isRow: isRow }) => (isRow ? "13px" : "38px")};
    font-family: Pretendard;
    font-weight: 500;
    font-size: 14px;
    color: #808080;
  }
`;

export const EditTournamentSettingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 15px;
  height: 468px;
`;

export const EditTournamentSettingBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  padding-bottom: 40px;
`;

export const EditTournamentSettingInputBox = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  > .name {
    font-family: Pretendard;
    font-weight: 600;
    font-size: 15px;
    width: 70px;
  }

  > input {
    width: 100px;
    height: 20px;
    border-radius: 2.7px;
    padding: 5px 8px;
    border: 0.67px solid var(--Black-200, #b7b7b7);
    outline: none;
    font-family: Pretendard;
    font-weight: 500;
    font-size: 10.79px;
  }

  > span {
    font-family: Pretendard;
    font-weight: 400;
    font-size: 15px;
  }
`;

export const EditTournamentSettingTitle = styled.div`
  color: #1a191a;
  font-family: Pretendard;
  font-weight: 600;
  font-size: 17px;
  display: flex;
  align-items: center;
  gap: 10px;
  height: 24px;

  > img {
    cursor: pointer;
  }
`;

export const EditTournamentSettingPagination = styled.div`
  color: #b7b7b7;
  font-family: Pretendard;
  font-weight: 700;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 10px;
  position: absolute;
  bottom: 5px;

  > .page {
    text-align: center;
    width: 30px;
  }

  > img {
    cursor: pointer;
  }
`;
